import React from 'react';

const NewPostSkeleton = () => {
  return (
    <main className="p-6 lg:p-10 space-y-8">
      {/* Header Skeleton */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div
            style={{
              height: '48px',
              width: '48px',
              backgroundColor: '#e5e7eb',
              borderRadius: '12px',
              animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            }}
          />
          <div>
            <div
              style={{
                height: '32px',
                width: '140px',
                backgroundColor: '#d1d5db',
                borderRadius: '4px',
                marginBottom: '8px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
            <div
              style={{
                height: '20px',
                width: '220px',
                backgroundColor: '#e5e7eb',
                borderRadius: '4px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
          </div>
        </div>

        <div className="flex items-center gap-3">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div
              key={idx}
              style={{
                height: idx === 2 ? '56px' : '48px',
                width: idx === 0 ? '90px' : idx === 1 ? '130px' : '150px',
                backgroundColor: idx === 2 ? '#9ca3af' : '#e5e7eb',
                borderRadius: '12px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
          ))}
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column - Main Form */}
        <div className="lg:col-span-2 space-y-6">
          {/* Form Card Skeleton */}
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '1rem',
              boxShadow:
                '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
              padding: '2rem'
            }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <div
                style={{
                  height: '28px',
                  width: '160px',
                  backgroundColor: '#d1d5db',
                  borderRadius: '4px',
                  marginBottom: '1rem',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  height: '20px',
                  width: '280px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
            </div>

            {/* Text Input Skeleton */}
            <div style={{ marginBottom: '1.5rem' }}>
              <div
                style={{
                  height: '16px',
                  width: '80px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  height: '120px',
                  width: '100%',
                  backgroundColor: '#f3f4f6',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
            </div>

            {/* Image Upload Area Skeleton */}
            <div style={{ marginBottom: '1.5rem' }}>
              <div
                style={{
                  height: '16px',
                  width: '100px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  height: '200px',
                  width: '100%',
                  backgroundColor: '#f3f4f6',
                  borderRadius: '8px',
                  border: '2px dashed #d1d5db',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <div
                  style={{
                    height: '48px',
                    width: '48px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '50%',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
              </div>
            </div>

            {/* Social Networks Skeleton */}
            <div>
              <div
                style={{
                  height: '16px',
                  width: '140px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  marginBottom: '12px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                  gap: '12px'
                }}>
                {Array.from({ length: 4 }).map((_, idx) => (
                  <div
                    key={idx}
                    style={{
                      height: '48px',
                      backgroundColor: '#f3f4f6',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px',
                      gap: '8px'
                    }}>
                    <div
                      style={{
                        height: '20px',
                        width: '20px',
                        backgroundColor: '#d1d5db',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                      }}
                    />
                    <div
                      style={{
                        height: '16px',
                        flex: 1,
                        backgroundColor: '#e5e7eb',
                        borderRadius: '4px',
                        animation:
                          'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Settings & Preview */}
        <div className="space-y-6">
          {/* Settings Card Skeleton */}
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '1rem',
              boxShadow:
                '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
              padding: '1.5rem'
            }}>
            <div
              style={{
                height: '24px',
                width: '100px',
                backgroundColor: '#d1d5db',
                borderRadius: '4px',
                marginBottom: '1rem',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />

            {/* Date/Time Skeleton */}
            <div style={{ marginBottom: '1rem' }}>
              <div
                style={{
                  height: '16px',
                  width: '80px',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
              <div
                style={{
                  height: '40px',
                  width: '100%',
                  backgroundColor: '#f3f4f6',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                }}
              />
            </div>

            {/* Toggle Options */}
            {Array.from({ length: 2 }).map((_, idx) => (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  borderTop: idx > 0 ? '1px solid #f3f4f6' : 'none'
                }}>
                <div
                  style={{
                    height: '16px',
                    width: '120px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '4px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
                <div
                  style={{
                    height: '24px',
                    width: '44px',
                    backgroundColor: '#d1d5db',
                    borderRadius: '12px',
                    animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                  }}
                />
              </div>
            ))}
          </div>

          {/* Preview Card Skeleton */}
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: '1rem',
              boxShadow:
                '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
              padding: '1.5rem'
            }}>
            <div
              style={{
                height: '24px',
                width: '80px',
                backgroundColor: '#d1d5db',
                borderRadius: '4px',
                marginBottom: '1rem',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
            <div
              style={{
                height: '300px',
                width: '100%',
                backgroundColor: '#f3f4f6',
                borderRadius: '8px',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </main>
  );
};

export default NewPostSkeleton;
